const language = {
  en: {
    inputPlaceHolder: "What do you want to WATCH Today?",
    searchButtonLabel: "Search",
  },
  kn: {
    inputPlaceHolder: "ನೀವು ಇಂದು ಏನು ನೋಡಲು ಬಯಸುತ್ತೀರಿ?",
    searchButtonLabel: "ಹುಡುಕು",
  },
};

export default language;
